import { Routes } from '@angular/router';
import { SearchPageComponent } from './pages/search-page/search-page.component';
import { ClaimFoundComponent } from './pages/claim-found/claim-found.component';
import { ClaimNotFoundComponent } from './pages/claim-not-found/claim-not-found.component';
import { ClaimsFoundComponent } from './pages/claims-found/claims-found.component';
import { ErrorComponent } from './pages/error/error.component';

export const routes: Routes = [
    { path: 'search-page', component: SearchPageComponent},
    { path: '', redirectTo: '/search-page', pathMatch: 'full'},
    { path: 'claim-found', component: ClaimFoundComponent},
    { path: 'claims-found', component: ClaimsFoundComponent},
    { path: 'claim-not-found', component: ClaimNotFoundComponent},
    { path: 'error', component: ErrorComponent}
];
